import { IncidentsActivityPanelBaseDataProvider } from './IncidentsActivityPanelBaseDataProvider';
import { IncidentsActivityPanelWebComponentSchema } from '../types';

export class IncidentsActivityPanelNirvanaDataProvider extends IncidentsActivityPanelBaseDataProvider {
  async getDataForView(): Promise<IncidentsActivityPanelWebComponentSchema> {
    return {} as unknown as IncidentsActivityPanelWebComponentSchema;
  }
}
